// form v3 purpose
export const __PURPOSE_REDEMPTION__ = "PURPOSE_REDEMPTION"; // redemption
export const __PURPOSE_CUSTOMIZED__ = "PURPOSE_CUSTOMIZED"; // customized
export const __PURPOSE_HK_CAMPAIGN__ = "PURPOSE_HK_CAMPAIGN"; // hk 问卷调查
export const __PURPOSE_EMAIL__ = "PURPOSE_EMAIL";// Email
export const __PURPOSE_TRACKING__ = "PURPOSE_TRACKING";// 埋点触发的事件
export const __PURPOSE_CONTACT__ = "PURPOSE_CONTACT";// contact
export const __PURPOSE_NONE__ = "PURPOSE_NONE";// purpose none
export const __PURPOSE_CANADA_CAMPAIGN__ = "PURPOSE_CANADA_CAMPAIGN";// Canada Campaign
export const __PURPOSE_ZENDESK__ = "PURPOSE_ZENDESK"; // redemption
export const __PURPOSE_CALL_EXPERT__ = "PURPOSE_CALL_EXPERT"; // call expert
